import React, { useId, useRef, useState } from "react";
import useDismissibleLayer from "../hooks/useDismissibleLayer";
import { useTranslation } from "../hooks/useTranslation";
import "./LanguageSwitcher.css";

const LanguageSwitcher = () => {
  const { locale, setLocale, locales } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const dropdownId = useId();

  const currentLocale =
    locales.find((item) => item.code === locale) || locales[0];

  useDismissibleLayer({
    isOpen,
    onClose: () => setIsOpen(false),
    containerRef: dropdownRef,
    returnFocusRef: buttonRef,
  });

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const selectLocale = (localeCode) => {
    setLocale(localeCode);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher">
      <button
        ref={buttonRef}
        className={`language-switcher__button ${isOpen ? "is-open" : ""}`}
        onClick={toggleDropdown}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-controls={dropdownId}
        aria-label="Select language"
        type="button"
      >
        <span className="language-switcher__globe" aria-hidden="true">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="1.5"
            />
            <path
              d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
              stroke="currentColor"
              strokeWidth="1.5"
            />
          </svg>
        </span>
        <span className="language-switcher__current">{currentLocale.name}</span>
        <span
          className={`language-switcher__arrow ${isOpen ? "is-open" : ""}`}
          aria-hidden="true"
        >
          ▼
        </span>
      </button>

      {isOpen && (
        <div
          ref={dropdownRef}
          className="language-switcher__dropdown"
          id={dropdownId}
          role="menu"
          aria-label="Language options"
        >
          {locales.map((localeOption) => (
            <button
              key={localeOption.code}
              className={`language-switcher__option ${
                localeOption.code === locale ? "is-selected" : ""
              }`}
              onClick={() => selectLocale(localeOption.code)}
              role="menuitemradio"
              aria-checked={localeOption.code === locale}
              type="button"
            >
              {localeOption.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
